      document.addEventListener('submit', function (e) {
          if (!e.target.action) return;
          if (!e.target.action.includes('/cart/add')) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          const btn = e.target.querySelector('.btn-add-to-bag');
          const iconSrc = btn?.dataset.iconSrc || '/assets/bag-icon.svg';
          if (btn) btn.classList.add('loading');

          const formData = new FormData(e.target);
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          })
            .then((r) => r.json())
            .then(() => {
              return Promise.all([
                fetch('/?sections=mini-cart').then((r) => r.json()),
                fetch('/cart.js').then((r) => r.json()),
              ]);
            })
            .then(([sectionData, cartData]) => {
              if (btn) {
                btn.classList.remove('loading');
                const textEl = btn.querySelector('.btn-text');
                if (textEl) {
                  textEl.innerHTML = `✔ Added`;
                  setTimeout(() => {
                    textEl.innerHTML = `<img src="${iconSrc}" alt=""> Add to bag`;
                  }, 2000);
                }
              }

              const parser = new DOMParser();
              const doc = parser.parseFromString(sectionData['mini-cart'], 'text/html');
              const newContent = doc.querySelector('#shopify-section-mini-cart');
              const currentContent = document.querySelector('#shopify-section-mini-cart');
              if (newContent && currentContent) {
                currentContent.innerHTML = newContent.innerHTML;
              }

              const el = document.querySelector('[data-cart-count]');
              if (el && cartData.item_count > 0) {
                el.textContent = cartData.item_count;
                el.removeAttribute('hidden');
                el.classList.remove('bump');
                void el.offsetWidth;
                el.classList.add('bump');
              }

              document.querySelector('.custom-cart-drawer')?.classList.add('is-open');
              document.querySelector('.cart-drawer-overlay')?.classList.add('is-open');
              document.body.style.overflow = 'hidden';
              document.documentElement.style.overflow = 'hidden';
              document.body.classList.add('cart-open');
            });
        },
        true
      );